import { isHiddenLocale, isPausedNewMarketLocale, type LocaleIso } from './locale';
import { translateCountry } from './shared';

export type Page = {
  siteBranch: number;
  homepage: string;
  locale: string;
  name: string;
};

export type PageCollection = Page[];

export interface Pages {
  [key: string]: Page;
}

// Pages by SiteBranch ID
export function createPage(siteBranch: number, homepage: string, locale: LocaleIso, name: string): Page {
  return {
    siteBranch,
    homepage,
    locale,
    name
  };
}

export const PAGES: Pages = {
  Belgie: createPage(38, 'https://nl.pixum.be', 'nl-BE', translateCountry('nl-BE', 'BE')),
  Belgique: createPage(37, 'https://fr.pixum.be', 'fr-BE', translateCountry('fr-BE', 'BE')),
  Bulgaria: createPage(143, 'https://www.pixum.bg', 'bg-BG', translateCountry('bg-BG', 'BG')),
  Czech: createPage(141, 'https://www.pixum.cz', 'cs-CZ', translateCountry('cs-CZ', 'CZ')),
  Denmark: createPage(51, 'https://www.pixum.dk', 'da-DK', translateCountry('da-DK', 'DK')),
  Germany: createPage(0, 'https://www.pixum.de', 'de-DE', translateCountry('de-DE', 'DE')),
  Austria: createPage(16, 'https://www.pixum.at', 'de-AT', translateCountry('de-AT', 'AT')),
  Schweiz: createPage(17, 'https://www.pixum.ch', 'de-CH', translateCountry('de-CH', 'CH')),
  Luxembourg: createPage(138, 'https://www.pixum.lu', 'de-LU', translateCountry('de-LU', 'LU')),
  Spain: createPage(48, 'https://www.pixum.es', 'es-ES', translateCountry('es-ES', 'ES')),
  France: createPage(24, 'https://www.pixum.fr', 'fr-FR', translateCountry('fr-FR', 'FR')),
  Hungary: createPage(142, 'https://www.pixum.hu', 'hu-HU', translateCountry('hu-HU', 'HU')),
  Ireland: createPage(62, 'https://www.pixum.ie', 'en-IE', translateCountry('en-IE', 'IE')),
  Italy: createPage(47, 'https://www.pixum.it', 'it-IT', translateCountry('it-IT', 'IT')),
  Netherlands: createPage(14, 'https://www.pixum.nl', 'nl-NL', translateCountry('nl-NL', 'NL')),
  Poland: createPage(140, 'https://www.pixum.pl', 'pl-PL', translateCountry('pl-PL', 'PL')),
  Portugal: createPage(1, 'https://www.pixum.pt', 'pt-PT', translateCountry('pt-PT', 'PT')),
  Svizzera: createPage(135, 'https://it.pixum.ch', 'it-CH', translateCountry('it-CH', 'CH')),
  Suisse: createPage(123, 'https://fr.pixum.ch', 'fr-CH', translateCountry('fr-CH', 'CH')),
  Finland: createPage(61, 'https://www.pixum.fi', 'fi-FI', translateCountry('fi-FI', 'FI')),
  Sweden: createPage(52, 'https://www.pixum.se', 'sv-SE', translateCountry('sv-SE', 'SE')),
  UK: createPage(18, 'https://www.pixum.co.uk', 'en-GB', translateCountry('en-GB', 'GB')),
  International: createPage(1, 'https://www.pixum.com', 'en', translateCountry('en', 'EN'))
};

export function getPageCollection(): Page[] {
  return Object.values(PAGES);
}

export function filterVisiblePages(pages: Page[]): Page[] {
  return pages.filter(page => !isHiddenLocale(page.locale) && !isPausedNewMarketLocale(page.locale));
}

export function getPageByLocale(locale: LocaleIso): Page {
  return Object.values(PAGES).find(page => page.locale === locale) as Page;
}
